import { queryOptions, useQuery } from '@tanstack/react-query'
import reallocationQueryKeys from './reallocationQueryKeys'
import { fetchReallocations } from '../service/reallocationService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'

export const useFetchReallocations = () => {
  const { companyId } = useContextParameters()

  return useQuery(
    queryOptions({
      queryKey: reallocationQueryKeys.list({ companyId }),
      queryFn: fetchReallocations,
      enabled: !!companyId
    })
  )
}
